import { extKm } from '../globals.js';
/**
 * Portal Manta · Dados
 * Extraído de portal_manta_v28_12.jsx
 * v29 modular · 2026-05-11
 */

export const PAYLOAD_LOTE1_PR = {
  "_label": "Lote 1 · PR (extraído PER Vol I+II)",
  "qual": {
    "nome": "Lote 1 · Paraná · Concessão Rodoviária Federal · 30 anos",
    "codManta": "MNT-PR-L1-2026",
    "ufPrincipal": "PR",
    "ufsSec": "",
    "cidade": "Curitiba (sede da concessão)",
    "tipoObra": "Concessão Rodoviária Federal",
    "concessionaria": "Lote 1 Rodovias Paranaenses (a outorgar)",
    "regulador": "ANTT",
    "fiscalSec": "PRF (Polícia Rodoviária Federal), BPRv (Batalhão da Polícia Rodoviária do Paraná)",
    "financiador": "BNDES",
    "ctxRural": 75,
    "ctxUrbano": 15,
    "ctxSerra": 10,
    "chuvaMM": 1500,
    "chuvaDias": 130,
    "chuvaRegime": "Subtropical",
    "altitudeMedia": 900,
    "biomaPredominante": "Mata Atlântica",
    "prazoAnos": 30,
    "dataEstudo": "2023-05-02",
    "nivelDetalhe": "PER + MEF",
    "fonteOrcamento": "SICRO",
    "anoBaseSicro": "2024",
    "notas": "Lote 1 do leilão PR 2023 · 7 rodovias (4 federais + 3 estaduais) · 473,01 km · 343,81 km de duplicação · 98 interseções · 12 passarelas · dados extraídos do JSON PER consolidado"
  },
  "kpis": {
    "extKm": 473.01,
    "extPistaSimples": 384.42,
    "extPistaDupla": 88.59,
    "dupKm": 343.81,
    "fxKm": 0,
    "ciclKm": 13.7,
    "oaeQt": 70,
    "oaeNovasQt": 0,
    "passQt": 12,
    "areaEscapeQt": 1,
    "interQt": 98,
    "retornoXQt": 9,
    "margTrechos": 28,
    "acessosQt": 92,
    "travUrbanasQt": 27,
    "correcoesTracadoQt": 20,
    "ilumCurvasQt": 44,
    "dispositivosEspQt": 1
  },
  "fontes": {
    "nome": "extraido", "codManta": "preset", "ufPrincipal": "extraido",
    "cidade": "extraido", "tipoObra": "extraido",
    "concessionaria": "extraido", "regulador": "extraido", "fiscalSec": "extraido", "financiador": "preset",
    "ctxRural": "preset", "ctxUrbano": "preset", "ctxSerra": "preset",
    "chuvaMM": "preset", "chuvaDias": "preset", "chuvaRegime": "preset",
    "altitudeMedia": "preset", "biomaPredominante": "preset",
    "prazoAnos": "extraido", "dataEstudo": "extraido",
    "nivelDetalhe": "preset", "fonteOrcamento": "preset", "anoBaseSicro": "preset",
    "notas": "extraido",
    "extKm": "extraido", "extPistaSimples": "extraido", "extPistaDupla": "extraido",
    "dupKm": "extraido", "ciclKm": "extraido",
    "oaeQt": "extraido", "passQt": "extraido", "areaEscapeQt": "extraido",
    "interQt": "extraido", "retornoXQt": "extraido", "margTrechos": "extraido",
    "acessosQt": "extraido", "travUrbanasQt": "extraido",
    "correcoesTracadoQt": "extraido", "ilumCurvasQt": "extraido", "dispositivosEspQt": "extraido"
  }
};
